<template>
  <div class="tree-table">
      <table>
        <thead>
        <tr>
          <th style="width: 150px;">科目编码</th>
          <th style="width: 150px;">科目名称</th>
          <th style="width: 130px;">收支类型</th>
          <th style="width: 100px;">是否末级</th>
          <th style="width: 180px;">科目说明</th>
          <!--        <th>操作</th>-->
        </tr>
        </thead>
        <tbody style="border-left: 1px solid #ddd">
        <tree-row v-for="(item, index) in data" :key="item.id" :item="item" :subjectTypeId="subjectTypeId" :index="index"></tree-row>
        </tbody>
      </table>
  </div>
</template>

<script>
import SubjectTemplateTreeRow from './subjectTemplateTreeRow.vue';
import Decimal from "decimal.js";

export default {
  name: 'TreeTable',
  components: {
    TreeRow: SubjectTemplateTreeRow
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    subjectTypeId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      preAnnualAmount: 0,
      currentAnnualAmount: 0,
      diff: 0,
      diffPercent: 0
    }
  },
  // created() {
  //   this.getSumNum()
  // },
  // mounted() {
  //   this.getSumNum()
  // },
  methods: {
    getSumNum() {
      this.preAnnualAmount = 0
      this.currentAnnualAmount = 0
      this.data.forEach(item => {
        this.preAnnualAmount = new Decimal(item.preAnnualPaidAmount).add(this.preAnnualAmount)
        this.currentAnnualAmount = new Decimal(item.currentAnnualBudgetAmount).add(this.currentAnnualAmount)
      })
      this.preAnnualAmount = new Decimal(this.preAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.currentAnnualAmount = new Decimal(this.currentAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.diff = new Decimal(this.currentAnnualAmount).sub(this.preAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.diffPercent = new Decimal(this.preAnnualAmount).eq(0) ? 0 : new Decimal(this.diff).div(this.preAnnualAmount).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
    }
  }
};
</script>

<style scoped>
.tree-table {
  width: 100%;
  font-size: 12px;
  overflow-x: auto;
  touch-action: pan-x pan-y; /* 允许横向滑动 */
  -webkit-overflow-scrolling: touch; /* iOS 惯性滚动 */
  margin: 20px 0;
  position: relative;
  z-index: 1;
  pointer-events: auto;
}

table {
  width: 710px;
  border-collapse: collapse;
  table-layout: fixed; /* 使表格宽度固定 */
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
  white-space: nowrap;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}

.child-rows table {
  width: 710px;
  table-layout: fixed;
}
</style>
